// Configuration file for API endpoints and services
// Use environment variables in production

// Detect development mode - check multiple conditions
const isDevelopment = 
  process.env.NODE_ENV === 'development' || 
  (typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === ''
  ));

// For development, use localhost backend (must be running on port 5000)
// For production, use production URL
// If REACT_APP_API_BASE_URL is set, use that (overrides everything)
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (isDevelopment ? 'http://localhost:5000' : 'https://redhand.vippanel.in');

// Log for debugging (remove in production)
if (isDevelopment && typeof window !== 'undefined') {
  console.log('🔧 Development mode detected');
  console.log('📡 API_BASE_URL:', API_BASE_URL);
  console.log('💡 Make sure backend is running on http://localhost:5000');
}

export const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL || 
  (isDevelopment ? 'http://localhost:5000' : 'https://redhand.vippanel.in');

export const APP_NAME = 'Secureye';
export const APP_DOMAIN = 'secureye.pages.dev';

const config = {
  API_BASE_URL,
  SOCKET_SERVER_URL,
  APP_NAME,
  APP_DOMAIN
};

export default config;
